export default {
  name: "specList",
  methods: {
    directionClass() {
      if (this.$store.state.locale == 'ar') return 'directionRight container'
      else return 'directionLeft container'
    }
  }
};
